import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-co-up-left",
  "use": "icon-co-up-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-corner-up-left\" id=\"icon-co-up-left\"><polyline points=\"9 14 4 9 9 4\" /><path d=\"M20 20v-7a4 4 0 0 0-4-4H4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol